(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wa-stock-cta"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-wa-block]').forEach(function(block) {
      var threshold = parseInt(block.dataset.warnThreshold, 10) || 0;
      var warn = block.querySelector('[data-wa-warn]');
      var link = block.querySelector('[data-wa-link]');
      var phone = block.dataset.phone;
      var baseMsg = block.dataset.baseMsg;
      var prodTitle = block.dataset.productTitle;
      var prodUrl = block.dataset.productUrl;

      if (!phone) return;

      // Buscar el quantity selector más cercano del formulario de producto
      var form = block.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      function update() {
        var q = parseInt(qtyInput.value, 10) || 1;
        if (threshold > 0 && q > threshold) {
          if (warn) warn.hidden = false;
          // ajustar mensaje del link con la cantidad solicitada
          var msg = baseMsg + ' — ' + prodTitle + ' (necesito ' + q + ' uds, stock visible: ' + threshold + ') — ' + prodUrl;
          link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
        } else {
          if (warn) warn.hidden = true;
          var msg = baseMsg + ' — ' + prodTitle + ' — ' + prodUrl;
          link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
        }
      }

      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
      // botones +/- de Horizon emiten 'change'
      form.querySelectorAll('button[name="plus"], button[name="minus"], [data-quantity-change]').forEach(function(btn) {
        btn.addEventListener('click', function() { setTimeout(update, 50); });
      });
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
